var _desc, _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartup1(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1632px",
    height: "1038px",
    viewBox: "0 0 1632 1038",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.9785373,116.289892 L70.1174967,86.6007605 C70.1174967,86.6007605 106.240456,89.4733772 113.968091,85.4641916 C113.968091,85.4641916 123.41147,36.8666048 112.148226,9.95424551 L111.920064,8.90628743 L35.691267,0 L30.9487943,43.1591641 C28.3810646,35.5956012 7.65901023,27.5461976 2.11883456,38.3784132 C-9.88593571,61.8503234 33.0375237,77.6546886 33.0375237,77.6546886 L28.6798075,116.647048",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.0211864865 0.509679169 85.9066757 0.509679169 85.9066757 29.9830844 0.0211864865 29.9830844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.578149,83.5983788 L295.669425,103.218352 C295.669425,103.218352 343.235177,83.714298 367.702796,91.1148219 L285.252396,138.843015 L263.787482,84.9597754 L289.578149,83.5983788 Z M67.2234362,24.7195454 L40.5521981,49.1584444 C40.5521981,49.1584444 44.5143314,65.4193766 46.1843505,80.7564417 C48.60176,102.958013 47.115741,122.999828 47.115741,122.999828 L0.875664762,42.3497183 L57.9585981,1.27897692e-13 L67.2234362,24.7195454 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.619253,89.2315276 L266.117272,86.9366766 L271.136091,103.241187 L250.032168,112.036228 L240.619253,89.2315276 Z M33.0348343,2.7000624e-13 L35.9665676,30.9713365 L16.018339,49.1819768 L0.18032,24.8433087 L33.0348343,2.7000624e-13 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.540954,110.131242 L98.6756076,0.000261471815 L185.585817,0.000261471815 L231.333025,0.000610100902 C231.418903,26.9400512 228.246217,71.3118182 211.450522,121.83776 L264.775036,372.998521 C265.438146,376.152108 264.316908,379.301167 262.041251,381.33934 L270.144594,410.110436 L237.02547,419.752645 L229.136538,392.941896 L228.930084,393.009831 C224.233703,394.56123 219.178084,391.955228 217.73237,387.248735 L165.047247,215.898223 C159.105866,224.65741 152.631768,233.399176 145.59517,242.079932 C101.04176,297.041308 73.2744076,326.682624 58.993379,340.942425 C53.895399,346.042035 45.9644838,346.291001 40.5858509,342.124342 L20.2207238,358.893686 L4.54747351e-13,331.078314 L20.1258062,314.505266 C16.9000806,309.332806 17.4311283,302.607388 21.55376,298.017469 C42.074141,275.120382 99.8238552,205.194975 132.540808,110.131667 L132.540954,110.131242 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "126.784762 386.280941 112.83581 391.232346 56.8647619 197.167964 22.3340952 77.4478645 3.55271368e-13 0.000784415445 28.3097143 0.000784415445 33.2864762 19.5318574 71.6382095 169.957464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.216537,65.7313782 C274.180118,87.4016409 235.438085,158.537498 207.8186,147.191531 C187.1396,138.695654 162.3836,68.2621906 162.3836,68.2621906 L202.6246,44.3134809 L220.7066,92.7159208 L257.627928,52.6054152 C256.374235,44.6573319 255.370014,34.2675516 257.8693,30.6048578 C262.1243,24.3706378 283.6523,5.16295749 283.6523,5.16295749 L287.571948,37.7069615 L288.256612,34.9634797 C288.255921,34.8106965 288.292724,34.6453309 288.3703,34.4665748 C288.377756,34.4494131 288.385493,34.4321988 288.393508,34.4149325 L289.978345,28.064411 C289.313031,27.7286469 289.04079,27.25013 289.3284,26.5877575 C289.561846,26.0501254 290.070971,25.4608743 290.782649,24.8415272 L296.1936,3.15957684 C296.1936,3.15957684 297.969276,3.94940708 300.572631,5.13282269 C304.759977,4.26932449 319.923564,14.5777435 320.153653,14.7343755 L320.1566,14.7362777 C323.2446,16.7305123 315.9006,49.6910548 309.9356,55.8139317 C305.6919,60.169928 292.487002,63.9258449 285.216537,65.7313782 L285.216537,65.7313782 Z M38.6859101,212.706451 L41.1509,217.385606 C41.1509,217.385606 43.3819,221.209049 45.7179,227.882677 C48.0529,234.55531 47.0829,238.638222 52.1349,249.119387 C57.8699,261.017193 47.6119,256.111137 43.9339,250.917777 C41.0629,246.863694 41.3889,241.385017 37.6669,238.929504 C36.4199,240.919762 33.5699,243.764976 31.9799,260.931697 C31.6949,264.010533 33.0909,273.997612 33.0909,273.997612 C33.1209,276.989958 33.5049,283.230143 30.0979,284.182524 C29.2539,284.419128 28.1549,283.485636 28.1549,283.485636 C28.1549,283.485636 28.4849,287.390598 25.0039,288.168011 C23.6349,288.473211 20.9159,280.041953 20.9159,280.041953 C20.9159,280.041953 20.5019,284.323692 17.9019,284.799882 C17.1669,284.93409 8.4889,260.506208 8.4889,260.506208 L9.0109,266.023656 L10.1629,271.674319 C10.1629,271.674319 10.0699,274.716372 7.6269,275.254199 C6.6569,275.467938 4.7949,270.394867 3.0499,264.426082 C0.3359,255.138873 0.3909,248.160046 1.1899,241.219991 C2.1539,232.833469 1.7249,230.01609 5.4579,219.731765 C5.9043173,218.501808 6.50350333,217.089486 7.17268594,215.637288 C5.12447241,197.956588 -0.647281686,146.202808 0.0601,130.3145 C0.9171,111.043195 21.3351,68.2625883 21.3351,68.2625883 L62.7881,91.4368669 L39.9401,133.06726 L38.6859101,212.706451 L38.6859101,212.706451 Z M137.858,21.0061871 C113.848,19.5945156 103.718,4.67255074 101.408,0.636363059 C116.642,-0.415431662 118.234,-0.261340753 138.526,1.84026042 C146.756,2.69322816 152.528,4.44389972 158.118,5.97486746 C159.328,10.0806446 161.048,22.3582106 137.858,21.0061871 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.244745,43.7138035 L189.3883,43.6858663 L205.7423,81.283054 L182.400673,94.8875062 L177.5277,176.9749 L44.5377,176.9749 L42.3077,96.0224956 L0.2577,64.5780088 C0.2577,64.5780088 20.0877,24.8126129 54.0177,8.98598534 C64.9877,3.86619062 75.048,1.45024399 84.408,0.525698534 C85.1754049,0.449927119 84.5697696,0.471310759 84.6629639,0.833279696 C84.715857,1.03871793 84.901062,1.34487933 85.1159668,1.69222584 C85.3308716,2.03957235 85.3308716,1.92704652 86.3843994,3.48086772 C87.4379272,5.03468891 88.9994954,6.58357045 91.354248,8.98598534 C93.3073684,10.9786385 96.0053096,12.9296279 98.6523437,14.4088883 C101.666006,16.0930338 104.623858,17.2176477 106.521729,18.0160252 C108.234577,18.7365692 109.678711,19.1145249 111.074585,19.446065 C115.01748,20.3825591 118.087169,20.6726104 124.349121,20.998943 C125.109071,21.0385467 129.509325,20.7128092 130.283203,20.5590058 C131.387031,20.3396267 132.375977,20.1414254 133.624146,19.8010265 C134.872314,19.4606275 137.974173,18.0131188 140.027588,15.4633363 C140.89856,14.3818263 141.725934,10.8248193 141.471191,8.2042827 C141.216449,5.58374605 140.073661,5.57818342 141.118,5.86420293 C159.488,10.8647015 176.8487,21.1740792 186.9977,39.4562199 C187.815831,40.9289577 188.563411,42.3474911 189.244745,43.7138035 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-17",
    points: "0.8872 0.233621701 45.1692 0.233621701 45.1692 72.5965021 0.8872 72.5965021"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-19",
    points: "0.9044 0.233621701 20.0754 0.233621701 20.0754 72.5965021 0.9044 72.5965021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1028,59.607506 L31.1798,59.607506 L11.1798,19.1798716 L104.1028,19.1798716 L84.1028,59.607506 Z M105.282,19.1796799 L10,19.1796799 C4.477,19.1796799 -3.83693077e-13,14.8854784 -3.83693077e-13,9.59012761 C-3.83693077e-13,4.29381791 4.477,0.000575373134 10,0.000575373134 L105.282,0.000575373134 C110.805,0.000575373134 115.282,4.29381791 115.282,9.59012761 C115.282,14.8854784 110.805,19.1796799 105.282,19.1796799 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6680023,257.852362 C48.4287842,261.975083 54.1339361,269.687089 55.282,278.9088 C55.409,279.9268 55.479,280.9378 55.496,281.9378 C55.571,286.4738 49.855,288.4608 47.09,284.8658 C43.935,280.7638 39.756,278.3978 35.386,278.7848 C27.001,279.5278 21.091,290.1328 22.183,302.4768 C22.185,302.5028 22.187,302.5288 22.19,302.5548 C22.524,306.2338 18.77,308.8918 15.461,307.2528 C7.079,303.1038 0.995,294.8138 0.11,284.8118 C-0.949010512,272.847906 5.75209333,261.986338 16.0529988,257.199321 L16.053,62.0549577 C7.33666816,57.365804 1.4118,48.1586923 1.4118,37.568 C1.4118,26.0511104 8.41828834,16.1703822 18.4017792,11.9565693 C22.0172869,4.87678586 29.3896056,0.0004 37.8454,0.0004 L210.7004,0.0004 C218.403243,0.0004 225.206714,4.04633484 229.090687,10.1180776 C241.809865,8.11134136 254.625963,15.2018453 259.3748,27.7177 C264.499482,41.2241163 258.404869,56.2342955 245.703,62.4898105 L245.703,259.405871 C254.887796,264.793111 260.528225,275.245956 259.241,286.5021 C258.1,296.4791 251.806,304.6091 243.321,308.5431 C239.969,310.0971 236.286,307.3431 236.714,303.6751 C236.717,303.6481 236.719,303.6221 236.723,303.5971 C238.132,291.2851 232.495,280.5311 224.132,279.5741 C219.773,279.0761 215.534,281.3351 212.275,285.3531 C209.419,288.8771 203.756,286.7441 203.947,282.2121 C203.989,281.2121 204.086,280.2031 204.238,279.1891 C205.719551,269.347808 212.382113,261.371435 221.088,257.734356 L221.088,76.7362489 C217.994997,78.4243832 214.454511,79.3854 210.7004,79.3854 L40.668,79.3854 L40.668,257.852354 L40.6680023,257.852362 Z",
    id: "path-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.2684,106.501726 C154.800292,106.896055 159.166,111.509121 159.166,117.1414 L159.166,121.9364 L16.92,121.9364 L16.92,117.1414 C16.92,111.509148 21.2847517,106.896099 26.8174,106.501731 L26.8174,104.6024 C26.8174,98.1103962 31.5604715,92.6725854 37.7525,91.5830824 L37.7525,13.283 C37.7525,5.977 43.7305,0 51.0355,0 L125.0505,0 C132.3565,0 138.3335,5.977 138.3335,13.283 L138.3335,91.5831175 C144.525431,92.6727025 149.2684,98.1104661 149.2684,104.6024 L149.2684,106.501726 Z M171.8482,50.2469 C171.8482,57.3739 166.0712,63.1519 158.9442,63.1519 C151.8172,63.1519 146.0392,57.3739 146.0392,50.2469 C146.0392,43.1199 151.8172,37.3429 158.9442,37.3429 C166.0712,37.3429 171.8482,43.1199 171.8482,50.2469 Z M2.98427949e-13,50.2469 C2.98427949e-13,43.1199 5.778,37.3429 12.905,37.3429 C20.032,37.3429 25.81,43.1199 25.81,50.2469 C25.81,57.3739 20.032,63.1519 12.905,63.1519 C5.778,63.1519 2.98427949e-13,57.3739 2.98427949e-13,50.2469 Z",
    id: "path-25"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scene",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration-7",
    transform: "translate(-184.000000, -175.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-Object-/-Chair-/-5",
    transform: "translate(472.500000, 862.000000) scale(-1, 1) translate(-472.500000, -862.000000) translate(0.000000, 504.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(185.000000, 143.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#B6D4FF",
    points: "480.8133 340.6099 518.5573 429.3129 535.6733 429.3129 512.9663 336.2619"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#B6D4FF",
    points: "288 340.6099 325.743 429.3129 342.859 429.3129 320.152 336.2619"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#B6D4FF",
    points: "0 429.313 17.116 429.313 54.859 340.61 22.707 336.262"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#B6D4FF",
    points: "192.8133 429.313 209.9293 429.313 247.6733 340.61 215.5203 336.262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0471,133.0201 L21.0471,347.8001 L244.2601,348.2771 L280.9671,135.8161 L21.0471,133.0201 Z M38.0471,150.2041 L260.8161,152.6001 L229.9501,331.2471 L38.0471,330.8371 L38.0471,150.2041 Z",
    id: "Fill-5",
    fill: "#B6D4FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#CCE3FF",
    points: "313.9578 0.9994 253.9588 348.2774 515.7078 348.2774 575.7088 0.9994"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#DCEEFF",
    points: "243.5724 0.9994 183.5724 348.2774 442.1474 348.2774 502.1474 0.9994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4611,348.2774 L487.2551,348.2774 C502.9691,348.2774 515.7081,335.5384 515.7081,319.8234 L515.7081,254.2474 C515.7081,238.5324 502.9691,225.7934 487.2551,225.7934 L179.4611,225.7934 C163.7461,225.7934 151.0071,238.5324 151.0071,254.2474 L151.0071,319.8234 C151.0071,335.5384 163.7461,348.2774 179.4611,348.2774",
    id: "Fill-8",
    fill: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#DCEEFF",
    points: "19.891 348.277 292.495 348.277 292.495 225.793 19.891 225.793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.4953,133.0201 L292.4953,347.8001 L515.7083,348.2771 L552.4163,135.8161 L292.4953,133.0201 Z M309.4953,150.2041 L532.2643,152.6001 L501.3983,331.2471 L309.4953,330.8371 L309.4953,150.2041 Z",
    id: "Fill-12",
    fill: "#B6D4FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background-Object-/-Closet-/-1",
    transform: "translate(978.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(302.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#DCEEFF",
    points: "0 900.576 26.534 900.576 26.534 814.374 0 814.374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#DCEEFF",
    points: "221.017 900.576 247.551 900.576 247.551 814.374 221.017 814.374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#B6D4FF",
    points: "94.112 900.576 120.645 900.576 120.645 814.374 94.112 814.374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#B6D4FF",
    points: "315.128 900.576 341.662 900.576 341.662 814.374 315.128 814.374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#B6D4FF",
    points: "93.959 829.669 341.508 829.669 341.508 97.411 93.959 97.411"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#DCEEFF",
    points: "0.499 829.669 248.05 829.669 248.05 97.411 0.499 97.411"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.9657,47.6177 C168.9657,68.6577 157.8507,87.1177 141.1787,97.4107 L79.9747,97.4107 C63.3017,87.1177 52.1867,68.6577 52.1867,47.6177 C52.1867,37.8267 54.5957,28.6087 58.8417,20.5137 L162.3117,20.5137 C166.5567,28.6087 168.9657,37.8267 168.9657,47.6177",
    id: "Fill-7",
    fill: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#DCEEFF",
    points: "184.488 97.398 209.723 97.398 209.723 1 184.488 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#CCE3FF",
    points: "159.252 97.398 184.487 97.398 184.487 1 159.252 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#CCE3FF",
    points: "209.723 97.398 234.958 97.398 234.958 1 209.723 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.748,97.398 L234.958,97.398 L234.958,1 L302.748,1 C305.58,1 307.876,3.295 307.876,6.128 L307.876,92.27 C307.876,95.102 305.58,97.398 302.748,97.398",
    id: "Fill-13",
    fill: "#B6D4FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#CCE3FF",
    points: "257.197 39.314 285.638 39.314 285.638 29.769 257.197 29.769"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#CCE3FF",
    points: "22.659 805.54 225.985 805.54 225.985 594.779 22.659 594.779"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#B6D4FF",
    points: "22.66 805.54 92.807 805.54 92.807 594.779 22.66 594.779"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#CCE3FF",
    points: "22.659 568.624 225.985 568.624 225.985 357.864 22.659 357.864"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#B6D4FF",
    points: "22.66 568.624 92.807 568.624 92.807 357.864 22.66 357.864"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#CCE3FF",
    points: "22.659 331.708 225.985 331.708 225.985 120.948 22.659 120.948"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#B6D4FF",
    points: "22.66 331.708 92.807 331.708 92.807 120.948 22.66 120.948"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#DCEEFF",
    points: "71.343 805.54 91.467 805.54 91.467 728.666 71.343 728.666"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#CCE3FF",
    points: "51.219 805.54 71.343 805.54 71.343 728.666 51.219 728.666"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#CCE3FF",
    points: "91.467 805.54 111.591 805.54 111.591 728.666 91.467 728.666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.6112,805.5396 L111.5902,805.5396 L111.5902,728.6656 L164.6112,728.6656 C167.4442,728.6656 169.7402,730.9616 169.7402,733.7936 L169.7402,800.4106 C169.7402,803.2436 167.4442,805.5396 164.6112,805.5396",
    id: "Fill-24",
    fill: "#B6D4FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#CCE3FF",
    points: "120.208 747.476 161.123 747.476 161.123 739.865 120.208 739.865"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#CCE3FF",
    points: "129.325 759.219 152.006 759.219 152.006 751.608 129.325 751.608"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7811,299.0679 C140.2211,312.1779 133.5811,323.7379 123.8821,331.7079 L60.4511,331.7079 C50.7521,323.7379 44.1111,312.1779 42.5421,299.0679 L141.7811,299.0679 Z",
    id: "Fill-27",
    fill: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7811,271.8199 C138.8291,296.5969 117.7391,315.8199 92.1631,315.8199 C66.5861,315.8199 45.4971,296.5969 42.5441,271.8199 L141.7811,271.8199 Z",
    id: "Fill-28",
    fill: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7811,244.6119 C140.2211,257.7219 133.5811,269.2819 123.8821,277.2519 L60.4511,277.2519 C50.7521,269.2819 44.1111,257.7219 42.5421,244.6119 L141.7811,244.6119 Z",
    id: "Fill-29",
    fill: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7811,217.3629 C138.8291,242.1409 117.7391,261.3639 92.1631,261.3639 C66.5861,261.3639 45.4971,242.1409 42.5441,217.3629 L141.7811,217.3629 Z",
    id: "Fill-30",
    fill: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.1054,517.9938 C109.1054,537.2888 107.0484,554.9368 103.6184,568.6238 L67.6744,568.6238 C64.2514,554.9368 62.1864,537.2888 62.1864,517.9938",
    id: "Fill-31",
    fill: "#ECF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.327,526.4723 C115.477,528.0813 120.78,535.9933 119.171,544.1433 C117.561,552.2933 109.65,557.5963 101.5,555.9873",
    id: "Stroke-32",
    stroke: "#ECF6FF",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1054,517.9938 C181.1054,537.2888 179.0484,554.9368 175.6184,568.6238 L139.6744,568.6238 C136.2514,554.9368 134.1864,537.2888 134.1864,517.9938",
    id: "Fill-33",
    fill: "#ECF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.535,526.4723 C179.685,528.0813 184.988,535.9933 183.379,544.1433 C181.769,552.2933 173.858,557.5963 165.708,555.9873",
    id: "Stroke-34",
    stroke: "#ECF6FF",
    strokeWidth: 8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background-Object-/-Bedside-table-/-5",
    transform: "translate(550.000000, 534.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(346.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9798,106.5515 L58.9798,106.5515 C58.9798,113.4545 64.5768,119.0515 71.4798,119.0515 L183.9488,119.0515 L183.9488,94.0505 L71.4798,94.0505 C64.5768,94.0505 58.9798,99.6475 58.9798,106.5515",
    id: "Fill-1",
    fill: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.6243,106.5515 L134.6243,106.5515 C134.6243,110.5475 137.8643,113.7875 141.8613,113.7875 L183.6473,113.7875 C183.8133,113.7875 183.9483,113.6535 183.9483,113.4875 L183.9483,99.6145 C183.9483,99.4485 183.8133,99.3145 183.6473,99.3145 L141.8613,99.3145 C137.8643,99.3145 134.6243,102.5545 134.6243,106.5515",
    id: "Fill-3",
    fill: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2825,119.0515 L43.2825,144.0525 L166.0415,144.0525 C172.9445,144.0525 178.5415,138.4555 178.5415,131.5525 C178.5415,124.6485 172.9445,119.0515 166.0415,119.0515 L43.2825,119.0515 Z",
    id: "Fill-5",
    fill: "#CCE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2825,124.3855 L43.2825,138.7195 L93.7565,138.7195 C97.7145,138.7195 100.9235,135.5105 100.9235,131.5525 C100.9235,127.5935 97.7145,124.3855 93.7565,124.3855 L43.2825,124.3855 Z",
    id: "Fill-7",
    fill: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4437,78.8083 L98.4277,0.9993 L123.3957,0.9993 L131.3807,78.8083 C132.2167,86.9623 125.8187,94.0503 117.6227,94.0503 L104.2017,94.0503 C96.0057,94.0503 89.6067,86.9623 90.4437,78.8083",
    id: "Fill-9",
    fill: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#DCEEFF",
    points: "0 322.201 152 322.201 152 144.053 0 144.053"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#B6D4FF",
    points: "152 322.201 253.144 322.201 253.144 144.053 152 144.053"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#CCE3FF",
    points: "13.624 305.149 135.76 305.149 135.76 239.789 13.624 239.789"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#CCE3FF",
    points: "13.624 225.101 135.76 225.101 135.76 159.741 13.624 159.741"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#DCEEFF",
    points: "0 364.312 14.891 364.312 14.891 322.201 0 322.201"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#B6D4FF",
    points: "238.253 364.312 253.144 364.312 253.144 322.201 238.253 322.201"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#DCEEFF",
    points: "137.108 364.312 152 364.312 152 322.201 137.108 322.201"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#B6D4FF",
    points: "99.538 364.312 114.429 364.312 114.429 322.201 99.538 322.201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5775,192.4216 C62.5775,199.1116 68.0015,204.5356 74.6925,204.5356 C81.3835,204.5356 86.8065,199.1116 86.8065,192.4216 C86.8065,185.7306 81.3835,180.3066 74.6925,180.3066 C68.0015,180.3066 62.5775,185.7306 62.5775,192.4216",
    id: "Fill-21",
    fill: "#B6D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5775,272.4695 C62.5775,279.1595 68.0015,284.5835 74.6925,284.5835 C81.3835,284.5835 86.8065,279.1595 86.8065,272.4695 C86.8065,265.7785 81.3835,260.3545 74.6925,260.3545 C68.0015,260.3545 62.5775,265.7785 62.5775,272.4695",
    id: "Fill-22",
    fill: "#B6D4FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Person-/-Man-/-7",
    transform: "translate(1362.500000, 843.500000) scale(-1, 1) translate(-1362.500000, -843.500000) translate(1023.000000, 329.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Man-/-Head-/-7",
    transform: "translate(245.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(38.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Face-color",
    transform: "translate(-0.000186, 32.602799)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#5E93D1",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#000000",
    opacity: 0.400274368,
    points: "70.1175824 119.203107 45.7603662 113.986826 70.0007851 130.341844"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#2437A8",
    points: "90.2102486 70.6867168 98.6268973 91.2389922 88.5397757 91.3673874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6133135,76.5273425 C81.1149081,79.2950731 79.2742189,81.9434503 76.502773,82.4443725 C73.7322324,82.9452946 71.0793946,81.1070731 70.5787054,78.3402467 C70.0771108,75.5725162 71.9168946,72.9232347 74.6883405,72.4223126 C77.4597865,71.9222946 80.1117189,73.759612 80.6133135,76.5273425",
    id: "Fill-8",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.086734,76.5273425 C107.588328,79.2950731 105.747639,81.9434503 102.976193,82.4443725 C100.205653,82.9452946 97.5528149,81.1070731 97.0521257,78.3402467 C96.5505311,75.5725162 98.3903149,72.9232347 101.161761,72.4223126 C103.933207,71.9222946 106.585139,73.759612 107.086734,76.5273425",
    id: "Fill-10",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(79.675676, 96.806371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0685391892,0.380483832 C0.0685391892,0.380483832 3.59418784,6.09045389 10.5775797,5.60671138",
    id: "Fill-12",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0685391892,0.380483832 C0.0685391892,0.380483832 3.59418784,6.09045389 10.5775797,5.60671138",
    id: "Stroke-14",
    stroke: "#252535",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.4090657,76.221773 C25.7169887,70.3276804 19.5219947,67.8304843 15.7643143,66.7933074 L16.4811851,51.9185922 L52.2890635,45.6823826 C49.8215504,62.2768115 40.2369777,71.330499 31.4090657,76.221773 L31.4090657,76.221773 Z",
    id: "Path",
    fill: "#EACB47"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ear-color",
    transform: "translate(9.959459, 66.005988)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.261438,48.3600557 C111.035478,45.2948461 90.0092486,44.3454449 64.7339514,46.2894569 C58.8551541,46.7415527 53.2190054,47.3111934 48.0074919,47.9712533 C30.7785324,50.1322713 18.1019514,53.2065228 16.0385324,55.9100557 C13.7496676,22.1294569 34.4644378,2.01119341 61.5858568,0.139516766 C79.3788838,-1.09018383 95.5150189,5.84496587 105.173884,20.2939479 C110.116492,27.6992772 113.368708,37.0847862 114.261438,48.3600557",
    id: "Fill-18",
    fill: "#393954"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(47.986486, 19.045892)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6825649,29.9830844 L66.6735108,29.9830844 C66.6391054,29.7479946 66.5005784,29.5219467 66.2751324,29.3139826 C63.049173,26.2487731 42.0229432,25.2993719 16.7476459,27.2433838 C10.8679432,27.6954796 5.2327,28.2651204 0.0211864865,28.9251802 C7.43464595,21.8905695 20.9958081,10.7690126 36.9934162,5.77787485 C43.8346595,3.64398263 50.7718757,2.08877305 57.1875784,1.24787485 C72.7605514,-0.813682036 85.2551459,1.30212635 85.8798757,9.37655749 C86.6856865,19.8832641 69.3707135,28.6810485 66.6825649,29.9830844",
    id: "Fill-22",
    fill: "#161629",
    mask: "url(#mask-4)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Man-/-Legs-/-7",
    transform: "translate(53.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(84.000000, 181.237430)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shoes",
    transform: "translate(0.000000, 314.077678)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#0D0B6D",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors-/-Wear-/-Black",
    mask: "url(#mask-6)",
    fill: "#19141E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.019048, 15.376809)",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 382,
    height: 124
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Legs-skin",
    transform: "translate(24.533333, 314.054494)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#CF3E83",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors-/-Skin-/-Pink",
    mask: "url(#mask-8)",
    fill: "#CF3E83",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.390476, 15.399993)",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 302,
    height: 97
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Pants",
    transform: "translate(28.547074, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#101016",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors-/-Wear-/-Blue",
    mask: "url(#mask-10)",
    fill: "#2437A8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.452926, 0.000000)",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 279,
    height: 423
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Overlay",
    transform: "translate(127.222682, 0.000261)",
    fill: "#FFFFFF",
    opacity: 0.0987490699
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.460931,392.941634 L130.254476,393.009569 C125.558095,394.560969 120.502476,391.954966 119.056762,387.248474 L66.3714286,215.897278 L33.8656381,110.131929 L-4.26325641e-14,1.13686838e-13 L86.9102095,1.13686838e-13 L112.774476,121.83715 L166.099429,372.99826 C166.762538,376.151847 165.6413,379.300906 163.365644,381.339079 L171.468987,410.110175 L138.349863,419.752384 L130.460931,392.941634 Z",
    id: "Mask"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pants-line",
    transform: "translate(148.663063, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EFEFEF",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors-/-Wear-/-Yellow",
    mask: "url(#mask-12)",
    fill: "#F6B852",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.289318, 0.000000)",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 126,
    height: 391
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Man-/-Body-/-5",
    transform: "translate(186.000000, 212.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(17.000000, 20.876833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skin-color",
    transform: "translate(0.000000, 20.766168)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E576C6",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors-/-Skin-/-Light-Red",
    mask: "url(#mask-14)",
    fill: "#ED4848",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.110665)",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 321,
    height: 288
  })))), /*#__PURE__*/React.createElement("g", {
    id: "T-Shirt",
    transform: "translate(17.000000, 20.876833)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#5E93D1",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors-/-Wear-/-Dark-Plum",
    mask: "url(#mask-16)",
    fill: "#0D0B6D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    x: 0,
    y: 0,
    width: 206,
    height: 177
  }))), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-16",
    stroke: "#000000",
    strokeWidth: 5,
    opacity: 0.200520833,
    points: "59.3058 116.895054 69.9728 124.113467 95.6138 94.3411152"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(270.000000, 0.760513)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8337402,63.5072983 L30.9762,72.5965021 L0.8872,72.5965021 L15.0802,0.233422874 L45.1692,0.233422874 C44.3892632,4.20993452 42.5522842,13.5757805 39.6582632,28.3309609 L33.7416992,25.5964397 L31.8989258,25.0871174 L30.4483,25.1683144 L29.8194916,25.5964397 L29.8194916,27.3546217 L36.2513428,36.5790091 L31.3311941,38.7166661 L23.7609863,42.6768194 L21.5737305,44.1870778 L20.7262883,44.9696921 L20.0343,45.5878712 L19.5932617,46.1186751 L19.3284,46.5934126 L19.2145833,47.2098935 L19.3284,47.4826981 L19.4599915,47.6924895 L19.6513977,47.881954 L22.1326904,48.7561442 L27.7929688,47.2098935 L33.387207,47.2098935 L25.920166,48.7561442 L21,51.6917527 L19.3284,53.2632916 L18.3836,54.4180997 L18.3836,55.4746161 L20.0343,56.2153577 L30.4483,55.0232789 L27,56.8939878 L24.7148437,58.3070214 L22.6201172,59.3846481 L21,61.4690305 L21,62.4976301 L21.5737305,63.1017321 L23.0282,63.8730589 L25.2460937,63.8730589 L29.7142474,63.8730589 L32.8337402,63.5072983 Z",
    id: "Fill-20",
    fill: "#5E93D1",
    mask: "url(#mask-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(265.000000, 0.760513)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#020101",
    mask: "url(#mask-20)",
    points: "5.8834 72.5965021 0.9044 72.5965021 15.0974 0.233422874 20.0754 0.233422874"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290.2574,9.39596657 C289.8414,11.5094974 288.6084,13.0494123 287.5034,12.833685 C286.3994,12.6189519 285.8404,10.7310897 286.2564,8.61755894 C286.6724,6.50303402 287.9054,4.9641132 289.0104,5.17884633 C290.1154,5.39457361 290.6734,7.28243578 290.2574,9.39596657",
    id: "Fill-34",
    fill: "#020101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Person-/-Robot-/-1",
    transform: "translate(473.000000, 519.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Robot-/-Legs-/-1",
    transform: "translate(36.000000, 295.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(0.000000, 41.235075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.8201,355.325323 L0.0001,355.325323 C1.9441,305.373346 32.6111,284.030838 79.3801,282.850364 C110.2521,199.151793 177.8951,284.544838 182.7641,218.338569 C188.4851,140.481954 190.1301,48.7195284 190.1301,48.7195284 L230.0101,49.3802485 C230.0101,49.3802485 233.3401,98.5075246 240.2501,198.59464 C245.1501,269.489241 295.0701,203.740394 360.6401,246.704465 C393.7391,268.393155 392.2631,320.861431 392.2631,320.861431 C392.2631,320.861431 420.8201,322.291234 420.8201,355.325323",
    id: "Fill-1",
    fill: "#B5B8BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.5902,355.325323 L41.3702,355.325323 C45.8602,333.173457 65.0302,317.015062 87.6102,314.799875 C91.9402,314.388484 96.3902,314.473831 100.8902,315.12592 C103.4802,315.509502 106.0002,316.056107 108.4402,316.775323 C115.1302,318.74214 121.1902,321.924913 126.3702,326.029241 C135.7202,333.404566 142.2402,343.760323 144.5902,355.325323",
    id: "Fill-3",
    fill: "#D7DADD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.9998,355.325323 L318.1398,355.325323 C320.4298,345.131629 327.7198,336.875025 337.3098,333.739241 C339.5698,333.000846 341.9598,332.540547 344.4498,332.415883 C345.8798,332.339166 347.2998,332.377525 348.6798,332.521368 C360.8498,333.75842 371.0198,342.983569 373.9998,355.325323",
    id: "Fill-5",
    fill: "#D7DADD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.18,355.325323 L123.56,355.325323 C122.9,349.015398 123.05,342.53286 124.09,335.983196 C124.63,332.578905 125.4,329.25229 126.37,326.029241 C137.41,289.532364 175.22,265.634241 215.46,271.503047 C224.97,272.893532 233.83,275.828894 241.81,280.00898 C269.48,294.470025 286.55,323.852413 283.18,355.325323",
    id: "Fill-7",
    fill: "#D7DADD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.4417,210.176614 C155.1327,218.426506 147.0977,224.095849 138.4957,222.840576 C129.8927,221.585304 123.9807,213.880099 125.2897,205.631166 C126.5987,197.381274 134.6327,191.711931 143.2357,192.967203 C151.8377,194.222476 157.7507,201.926722 156.4417,210.176614",
    id: "Fill-9",
    fill: "#D7DADD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.8328,213.041301 C270.2928,216.445592 266.9768,218.785443 263.4268,218.267607 C259.8758,217.748812 257.4358,214.569875 257.9768,211.164625 C258.5168,207.760334 261.8328,205.420484 265.3828,205.938319 C268.9328,206.457114 271.3728,209.636051 270.8328,213.041301",
    id: "Fill-11",
    fill: "#D7DADD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.8817,316.713375 C456.6347,324.569136 448.9827,329.969013 440.7897,328.774154 C432.5967,327.578337 426.9657,320.240412 428.2127,312.383692 C429.4597,304.526972 437.1117,299.127095 445.3047,300.322912 C453.4977,301.51777 459.1287,308.856654 457.8817,316.713375",
    id: "Fill-13",
    fill: "#D7DADD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Legs-color",
    transform: "translate(153.988800, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#6CA1FF",
    xlinkHref: "#path-21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors-/-Skin-/-Violet",
    mask: "url(#mask-22)",
    fill: "#A47EF1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.011200, 0.000000)",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115,
    height: 59
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Overlay",
    transform: "translate(165.000000, 19.179104)",
    fill: "#000000",
    opacity: 0.402157738
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    points: "72.923 40.4276343 20 40.4276343 -5.54223334e-13 -5.68434189e-14 92.923 -5.68434189e-14"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Robot-/-Body-/-1",
    transform: "translate(46.000000, 202.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(77.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body-color"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#6CA1FF",
    xlinkHref: "#path-23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors-/-Skin-/-Violet",
    mask: "url(#mask-24)",
    fill: "#A47EF1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.000000, -3.000000)",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 286,
    height: 312
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M127.1345,57.9864 C120.5345,57.9864 115.1345,52.5864 115.1345,45.9864 L115.1345,30.5384 C115.1345,23.9384 120.5345,18.5384 127.1345,18.5384 L193.5155,18.5384 C200.1155,18.5384 205.5155,23.9384 205.5155,30.5384 L205.5155,45.9864 C205.5155,52.5864 200.1155,57.9864 193.5155,57.9864 L127.1345,57.9864 Z M124.6999,38.2623 C124.6999,45.8203 130.8269,51.9473 138.3849,51.9473 C145.9419,51.9473 152.0689,45.8203 152.0689,38.2623 C152.0689,30.7043 145.9419,24.5783 138.3849,24.5783 C130.8269,24.5783 124.6999,30.7043 124.6999,38.2623 Z M162.2556,38.2623 C162.2556,45.8203 168.3826,51.9473 175.9406,51.9473 C183.4976,51.9473 189.6246,45.8203 189.6246,38.2623 C189.6246,30.7043 183.4976,24.5783 175.9406,24.5783 C168.3826,24.5783 162.2556,30.7043 162.2556,38.2623 Z",
    id: "Shape",
    fill: "#19141E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Overlay",
    transform: "translate(16.053000, 0.000400)",
    fill: "#000000",
    opacity: 0.401227679
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.035,257.3186 L205.035,76.7984281 C207.963124,74.0539161 209.920444,72.0645769 210.906961,70.8304105 C212.421233,68.9360037 213.725291,67.1032426 214.509622,66.1380277 C214.716278,65.8837119 214.955545,65.4590766 215.003015,65.3695532 C215.050485,65.2800299 215.039179,65.273958 215.124795,65.2806211 C215.999048,65.3486601 216.605765,65.3695532 217.3425,65.3695532 C219.049747,65.3695532 221.124854,65.1786106 223.443399,64.688809 C224.210226,64.5268138 225.285711,64.2172746 226.604043,63.775662 C227.222452,63.5685087 228.237771,63.1416492 229.65,62.4950834 L229.65,257.3186 L205.035,257.3186 Z M213.037687,10.1176776 C225.756865,8.11094136 238.572963,15.2014453 243.3218,27.7173 C248.7658,42.0653 241.5488,58.1103 227.1998,63.5543 C223.192657,65.0749922 219.053151,65.607988 215.049176,65.2738162 C215.961405,62.8761537 216.4614,60.2796234 216.4614,57.572 L216.4614,21.814 C216.4614,17.5188426 215.203416,13.5033226 213.037687,10.1176776 L213.037687,10.1176776 Z M6.4653721,64.5463567 C6.66435917,64.5908978 6.8680458,64.6328627 7.07676074,64.6717191 C7.85201353,64.8160477 8.75232276,65.0049484 9.77459004,65.1521778 C10.8796427,65.2858193 12.0046856,65.3546 13.1458,65.3546 C28.4928,65.3546 40.9328,52.9136 40.9328,37.5676 C40.9328,22.2216 28.4928,9.7806 13.1458,9.7806 C9.31644013,9.7806 5.66806851,10.55517 2.34877923,11.9561693 C5.96428687,4.87638586 13.3366056,0 21.7924,0 L49.1634,0 C61.1604,0 70.9764,9.816 70.9764,21.814 L70.9764,57.572 C70.9764,69.569 61.1604,79.385 49.1634,79.385 L24.615,79.385 L24.615,257.3186 L-5.68434189e-13,257.3186 L-5.68434189e-13,62.0660673 C0.171596973,62.1557734 0.339850726,62.2424478 0.504761259,62.3260904 L0.503073903,62.3185682 C2.37724028,63.2777939 4.37468747,64.0304077 6.4653721,64.5463567 L6.4653721,64.5463567 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M221.0876,234.6271 L245.7026,234.6271 L221.0876,234.6271 Z M221.0876,213.6271 L245.7026,213.6271 L221.0876,213.6271 Z M221.0876,192.6271 L245.7026,192.6271 L221.0876,192.6271 Z M221.0876,171.6271 L245.7026,171.6271 L221.0876,171.6271 Z M221.0876,150.6271 L245.7026,150.6271 L221.0876,150.6271 Z M221.0876,129.6271 L245.7026,129.6271 L221.0876,129.6271 Z M221.0876,108.6271 L245.7026,108.6271 L221.0876,108.6271 Z M221.0876,87.6271 L245.7026,87.6271 L221.0876,87.6271 Z M16.0525,234.6271 L40.6675,234.6271 L16.0525,234.6271 Z M16.0525,213.6271 L40.6675,213.6271 L16.0525,213.6271 Z M16.0525,192.6271 L40.6675,192.6271 L16.0525,192.6271 Z M16.0525,171.6271 L40.6675,171.6271 L16.0525,171.6271 Z M16.0525,150.6271 L40.6675,150.6271 L16.0525,150.6271 Z M16.0525,129.6271 L40.6675,129.6271 L16.0525,129.6271 Z M16.0525,108.6271 L40.6675,108.6271 L16.0525,108.6271 Z M16.0525,87.6271 L40.6675,87.6271 L16.0525,87.6271 Z",
    id: "Shape",
    stroke: "#19141E",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#19141E",
    points: "106 131.168 140.77 131.168 140.77 76 106 76"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Robot-/-Head-/-2",
    transform: "translate(159.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(8.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.6712,51.2464 L120.2062,51.2464",
    id: "Stroke-3",
    stroke: "#19141E",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6756,9.6986 C51.8836,9.6986 47.1436,14.4376 47.1436,20.2306",
    id: "Stroke-8",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5242,51.2464 L49.9952,51.2464",
    id: "Stroke-12",
    stroke: "#19141E",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face-color",
    transform: "translate(-0.000200, 0.999500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#6CA1FF",
    xlinkHref: "#path-25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors-/-Skin-/-Violet",
    mask: "url(#mask-26)",
    fill: "#A47EF1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000200, 0.000500)",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 172,
    height: 122
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Overlay",
    transform: "translate(-0.000200, 38.342400)",
    fill: "#000000",
    opacity: 0.395926339
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8174,69.1588312 L26.8174,65.8643871 C27.3968064,59.890266 32.7654,54.0415 40.0354,54.0415 L136.0504,54.0415 C143.3204,54.0415 148.463701,59.4409252 149.2684,65.433723 L149.2684,69.1588255 C154.800292,69.5531548 159.166,74.1662206 159.166,79.7985 L159.166,84.5935 L16.92,84.5935 L16.92,79.7985 C16.92,74.1662476 21.2847517,69.5531991 26.8174,69.1588312 L26.8174,69.1588312 Z M171.8482,12.904 C171.8482,20.031 166.0712,25.809 158.9442,25.809 C151.8172,25.809 146.0392,20.031 146.0392,12.904 C146.0392,5.777 151.8172,-1.77635684e-15 158.9442,-1.77635684e-15 C166.0712,-1.77635684e-15 171.8482,5.777 171.8482,12.904 Z M1.30917499e-12,12.904 C1.30917499e-12,5.777 5.778,-1.77635684e-15 12.905,-1.77635684e-15 C20.032,-1.77635684e-15 25.81,5.777 25.81,12.904 C25.81,20.031 20.032,25.809 12.905,25.809 C5.778,25.809 1.30917499e-12,20.031 1.30917499e-12,12.904 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.66,107.8182 L148.969,107.8182",
    id: "Stroke-19",
    stroke: "#19141E",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4569,72.2918 L138.3329,72.2918",
    id: "Stroke-21",
    stroke: "#19141E",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3333,34.3211 C73.7033,38.9551 72.8963,47.2761 77.5303,52.9061 C82.1643,58.5361 90.4853,59.3431 96.1153,54.7091 C101.7453,50.0751 102.5523,41.7541 97.9183,36.1241 C93.2843,30.4941 84.9633,29.6871 79.3333,34.3211",
    id: "Fill-23",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3885,39.9735 C83.8025,42.1025 83.4315,45.9245 85.5605,48.5115 C87.6895,51.0975 91.5115,51.4685 94.0975,49.3395 C96.6845,47.2105 97.0555,43.3885 94.9265,40.8015 C92.7975,38.2155 88.9745,37.8445 86.3885,39.9735",
    id: "Fill-25",
    fill: "#19141E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.0638,34.3211 C108.4338,38.9551 107.6268,47.2761 112.2608,52.9061 C116.8948,58.5361 125.2158,59.3431 130.8458,54.7091 C136.4758,50.0751 137.2828,41.7541 132.6488,36.1241 C128.0148,30.4941 119.6938,29.6871 114.0638,34.3211",
    id: "Fill-27",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.119,39.9735 C118.533,42.1025 118.162,45.9245 120.291,48.5115 C122.42,51.0975 126.242,51.4685 128.828,49.3395 C131.415,47.2105 131.786,43.3885 129.657,40.8015 C127.528,38.2155 123.705,37.8445 121.119,39.9735",
    id: "Fill-29",
    fill: "#19141E"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Background-Object-/-Picture-/-3",
    transform: "translate(524.000000, 279.000000) scale(-1, 1) translate(-524.000000, -279.000000) translate(274.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(123.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#DCEEFF",
    points: "122.095 194.756 253.089 194.756 253.089 0.5 122.095 0.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2",
    stroke: "#DCEEFF",
    strokeWidth: 9,
    points: "122.095 194.756 253.089 194.756 253.089 0.5 122.095 0.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFF",
    points: "0.5 194.756 245.999 194.756 245.999 0.5 0.5 0.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    stroke: "#DCEEFF",
    strokeWidth: 9,
    points: "0.5 194.756 245.999 194.756 245.999 0.5 0.5 0.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#FFFFFF",
    points: "23.097 173.623 223.402 173.623 223.402 21.633 23.097 21.633"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-8",
    stroke: "#DCEEFF",
    strokeWidth: 9,
    points: "23.097 173.623 223.402 173.623 223.402 21.633 23.097 21.633"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#B6D4FF",
    points: "73.768 136.906 173.748 136.906 173.748 58.349 73.768 58.349"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background-Object-/-Pluteus-/-4",
    transform: "translate(522.000000, 414.000000) scale(-1, 1) translate(-522.000000, -414.000000) translate(22.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(254.000000, 140.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#DCEEFF",
    points: "0 17.7762 423.177 17.7762 423.177 0.0002 0 0.0002"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#CCE3FF",
    points: "423.177 17.7762 492.795 17.7762 492.795 0.0002 423.177 0.0002"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#B6D4FF",
    points: "103.1409 17.7759 136.1869 69.6219 136.1869 17.7759"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#CCE3FF",
    points: "84.8529 17.7759 117.8989 69.6219 136.1869 69.6219 103.1409 17.7759"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#B6D4FF",
    points: "345.5172 17.7759 378.5642 69.6219 378.5642 17.7759"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#CCE3FF",
    points: "327.2292 17.7759 360.2762 69.6219 378.5642 69.6219 345.5172 17.7759"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background-Object-/-Picture-/-6",
    transform: "translate(722.000000, 332.000000) scale(-1, 1) translate(-722.000000, -332.000000) translate(472.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(209.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#DCEEFF",
    points: "5.766 89.2303 81.884 89.2303 81.884 0.5003 5.766 0.5003"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2",
    stroke: "#DCEEFF",
    strokeWidth: 5,
    points: "5.766 89.2303 81.884 89.2303 81.884 0.5003 5.766 0.5003"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFF",
    points: "0.5 89.2303 78.035 89.2303 78.035 0.5003 0.5 0.5003"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    stroke: "#DCEEFF",
    strokeWidth: 5,
    points: "0.5 89.2303 78.035 89.2303 78.035 0.5003 0.5 0.5003"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#CCE3FF",
    points: "18.852 66.1413 56.11 66.1413 56.11 23.4273 18.852 23.4273"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background-Object-/-Flower-/-3",
    transform: "translate(1257.000000, 503.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(387.000000, 135.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.0419,56.1488 C163.0419,56.1488 86.3679,225.3798 77.2129,409.3798 C77.2129,409.3798 120.1269,222.9188 163.0419,56.1488",
    id: "Fill-1",
    fill: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8553,186.2006 C25.8553,186.2006 81.0423,187.6366 89.4443,371.6366 C89.4443,371.6366 65.8933,232.7646 25.8553,186.2006",
    id: "Fill-3",
    fill: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2098,0.9994 C82.2098,0.9994 114.4258,195.6734 82.7158,393.7654 C82.7158,393.7654 84.5998,186.8714 82.2098,0.9994",
    id: "Fill-5",
    fill: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6669,445.8588 L45.9899,445.8588 C45.3919,445.8588 44.7959,445.8478 44.2019,445.8258 C7.8709,444.4678 -12.3421,398.5138 8.2339,365.3598 L26.4869,335.9518 L145.1699,335.9518 L163.4219,365.3598 C183.9989,398.5138 163.7859,444.4678 127.4549,445.8258 C126.8609,445.8478 126.2659,445.8588 125.6669,445.8588",
    id: "Fill-8",
    fill: "#ECF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0001,403.5893 L171.6569,403.5893",
    id: "Stroke-11",
    stroke: "#B6D4FF",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9842,375.1669 L168.2252,375.1669",
    id: "Stroke-14",
    stroke: "#B6D4FF",
    strokeWidth: 9
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background-Object-/-Picture-/-6",
    transform: "translate(320.000000, 332.000000) scale(-1, 1) translate(-320.000000, -332.000000) translate(70.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(209.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#DCEEFF",
    points: "5.766 89.2303 81.884 89.2303 81.884 0.5003 5.766 0.5003"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2",
    stroke: "#DCEEFF",
    strokeWidth: 5,
    points: "5.766 89.2303 81.884 89.2303 81.884 0.5003 5.766 0.5003"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFF",
    points: "0.5 89.2303 78.035 89.2303 78.035 0.5003 0.5 0.5003"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    stroke: "#DCEEFF",
    strokeWidth: 5,
    points: "0.5 89.2303 78.035 89.2303 78.035 0.5003 0.5 0.5003"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#CCE3FF",
    points: "18.852 66.1413 56.11 66.1413 56.11 23.4273 18.852 23.4273"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartup1);
export default __webpack_public_path__ + "static/media/startup1.46c1bbc7ae4e2a52096304a3e268afd2.svg";
export { ForwardRef as ReactComponent };